import React from "react";
import { service_insurance } from "../../../data/servicesData";
import InsuranceTabComponent from "../component/InsuranceTabComponent";

const InsurenceSection = () => {
  return (
    <div className="flex flex-col w-full items-center px-[5vw] sm:px-[10vw] xl:px-[15vw]">
      <div className="py-16 space-y-8 text-center xl:w-[60vw]">
        <div className="space-y-2">
          <h1 className="text-xl lg:text-2xl font-playfair uppercase">
            {service_insurance.title}
          </h1>
          <p className="italic">{service_insurance.sub_title}</p>
        </div>
        <div className="space-y-2 text-justify text-[#4c4c09]">
          <p>{service_insurance.para1}</p>
          <p>{service_insurance.para2}</p>
        </div>
        {/* tab section here */}
        <div className="w-full overflow-x-auto">
          {/* show the tab */}
          <InsuranceTabComponent />
        </div>
      </div>
    </div>
  );
};

export default InsurenceSection;
